/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedPeopleRouteImport } from './routes/_authed/people'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as AuthedRRoadmapIdRouteImport } from './routes/_authed/r.$roadmapId'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPeopleRoute = AuthedPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AuthedRoute,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRRoadmapIdRoute = AuthedRRoadmapIdRouteImport.update({
  id: '/r/$roadmapId',
  path: '/r/$roadmapId',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/people': typeof AuthedPeopleRoute
  '/s/$token': typeof STokenRoute
  '/r/$roadmapId': typeof AuthedRRoadmapIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/people': typeof AuthedPeopleRoute
  '/s/$token': typeof STokenRoute
  '/': typeof AuthedIndexRoute
  '/r/$roadmapId': typeof AuthedRRoadmapIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_authed/people': typeof AuthedPeopleRoute
  '/s/$token': typeof STokenRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/r/$roadmapId': typeof AuthedRRoadmapIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    '/' | '/login' | '/signup' | '/people' | '/s/$token' | '/r/$roadmapId'
  fileRoutesByTo: FileRoutesByTo
  to: '/login' | '/signup' | '/people' | '/s/$token' | '/' | '/r/$roadmapId'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/signup'
    | '/_authed/people'
    | '/s/$token'
    | '/_authed/'
    | '/_authed/r/$roadmapId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/people': {
      id: '/_authed/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof AuthedPeopleRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/r/$roadmapId': {
      id: '/_authed/r/$roadmapId'
      path: '/r/$roadmapId'
      fullPath: '/r/$roadmapId'
      preLoaderRoute: typeof AuthedRRoadmapIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedPeopleRoute: typeof AuthedPeopleRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedRRoadmapIdRoute: typeof AuthedRRoadmapIdRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedPeopleRoute: AuthedPeopleRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedRRoadmapIdRoute: AuthedRRoadmapIdRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
